export function RapydIframeStub() {
    const href = window.location.href;
    const status = href.split('?')[1];
    window.parent?.postMessage(status, window.location.origin);
    return <div/>;
}
